import { useState } from 'react'
import { Form, Head } from '@inertiajs/react'
import { Input, Button } from 'antd'

import LoginLayout from '@/components/layouts/LoginLayout'
import DeviceUserCard from '@/components/DeviceUserCard'

interface ResetPasswordProps {
  csrf_token: string
  reset_password_token: string
}

export default function ResetPassword({ csrf_token, reset_password_token }: ResetPasswordProps) {
  const [password, setPassword] = useState('')
  const [passwordConfirmation, setPasswordConfirmation] = useState('')
  const [loading, setLoading] = useState(false)
  return (
    <LoginLayout title="Reset Password">
      <Head title="Set New Password" />
      <DeviceUserCard title="Set a new password">
        <Form
          action="/password"
          method="put"
          onSubmit={() => setLoading(true)}
          onSuccess={() => setLoading(false)}
          onError={() => setLoading(false)}
        >
          <input type="hidden" name="authenticity_token" value={csrf_token} />
          <input type="hidden" name="_method" value="put" />
          <input type="hidden" name="user[reset_password_token]" value={reset_password_token} />
          <div className="mb-4">
            <label htmlFor="password" className="block text-sm font-medium text-gray-700 mb-1">
              New Password
            </label>
            <Input.Password
              id="password"
              name="user[password]"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter new password"
              required
            />
            <p className="text-xs text-gray-500 mt-1">Minimum 6 characters</p>
          </div>
          <div className="mb-4">
            <label htmlFor="password_confirmation" className="block text-sm font-medium text-gray-700 mb-1">
              Confirm Password
            </label>
            <Input.Password
              id="password_confirmation"
              name="user[password_confirmation]"
              value={passwordConfirmation}
              onChange={(e) => setPasswordConfirmation(e.target.value)}
              placeholder="Confirm new password"
              required
            />
          </div>
          <div className="mt-4">
            <Button
              type="primary"
              htmlType="submit"
              className="w-full text-white border-none rounded font-medium cursor-pointer mt-2 block"
              loading={loading}
              disabled={!password || !passwordConfirmation}
            >
              Reset password
            </Button>
          </div>
        </Form>
        <div className="mt-4 text-center">
          <a className="text-blue-500 text-sm" href="/login">
            Back to login
          </a>
        </div>
      </DeviceUserCard>
    </LoginLayout>
  )
}
